import API from '@/api';

export default {
    namespaced: true,
    state: {
        api_token: null,
        user: null,
    },
    getters: {

    },
    actions: {
        login({commit, dispatch}, data) {
            return API.sportid.login(data)
                .then(({data}) => {
                    dispatch('handleApiToken', data.api_token)
                    commit('setUser', data.user);
                });
        },
        register({commit, dispatch}, data) {
            return new Promise((resolve, reject) => {
                API.ijstijd.register(data)
                    .then(({data}) => {
                        dispatch('handleApiToken', data.api_token);
                        commit('setUser', data.user);
                        resolve(data);
                    })
                    .catch((response) => {
                        reject(response);
                    });
            });
        },
        logout({dispatch, state}) {
            return API.sportid.logout(state.api_token)
                .then(() => {
                    dispatch('clear');
                });
        },
        order(context, data) {
            return API.ijstijd.order(data);
        },
        // passwordLost({commit, dispatch}, data) {
        //     return API.ijstijd.post('forgot-password/request', data)
        // },
        // resetPassword({commit}, data) {
        //     return API.ijstijd.post('forgot-password/update', data)
        // },
        patch({commit}, data) {
            return API.ijstijd.patch(data)
                .then(({data}) => {
                    commit('setUser', data.user);
                });
        },
        handleApiToken({commit}, api_token) {
            commit('setApiToken', api_token);
            localStorage.setItem('api_token', JSON.stringify(api_token));
        },
        tokenRefresh({commit, dispatch}, api_token) {
            // Get profile info after user from SportID.
            return API.sportid.tokenRefresh(api_token)
                .then(({data}) => {
                    commit('setUser', data.user);
                    dispatch('handleApiToken', data.api_token);
                })
                .catch(() => {
                    // router.push({name: 'login'})
                    dispatch('clear')
                })
        },
        clear({commit}) {
            commit('clearApiToken');
            commit('setUser', null);
        }
    },
    mutations: {
        setApiToken: (state, api_token) => {
            state.api_token = api_token
        },
        setUser: (state, user) => {
            state.user = user
        },
        clearApiToken: state => {
            state.api_token = null
            localStorage.removeItem('api_token')
        },
    }
}